import PropTypes from 'prop-types';
import React from 'react';
import { ProgressBar } from './ProgressBar.js';
import { ProjectCost } from './ProjectCost.js';
import { AddToProjectFavoritesWidget, FAVORITES_STYLE } from './addToProjectFavoritesWidget.js';
import { GiveWidget } from './GiveWidget.js';
import { hasMatch, makeStillNeededWithMatch, makeTeacherAndSchoolInfo } from './projectUtils.js';
import { convertSmallPhotoToMediumSmall } from '../utils/userUtils.js';
import { projectFormatter } from './projectFormatter.js';
import '../../external/npm/html5-entities.js';


/* global userId */

export let SmallProjectCard = function ({ project, showGiveWidget, prepopulatedDonationAmountForGiveWidget, giveWidgetSubmitTakesUserDirectlyToCart, className, amountGiven, onProjectCardClick, altViewForFullyFundedProjects}) {
    const defaultImage = baseCacheURL + 'images/classroom/fallback-photo1@2x.png';
    const proposalURL = projectFormatter.removeUTMParams(project.proposalURL, project.teacherId);
    const imageURL = convertSmallPhotoToMediumSmall(project.imageURL) || defaultImage;
    const incomplete = parseFloat(project.costToComplete) > 0;

    const makeMatchExplanation = function () {
        if (hasMatch(project)) {
            var multiplier = project.matchingFund.multipleForDisplay;
            var badgeClass = project.matchingFund.multipleForDisplay === '1.5X'
                ? 'onepointfive' : 'DYI';
            return (
                <span className="match-offer-explanation">
                    <span className={'match-offer-badge ' + badgeClass}>
                        <span className="match-offer-badge-content">{multiplier}</span>
                    </span>
                    <strong><span>{makeStillNeededWithMatch(project)}</span> </strong>
                    for now, thanks to a match
                </span>
            );
        }
    };

    const onClick = function (event) {
        if (onProjectCardClick) {
            onProjectCardClick(parseInt(event.currentTarget.getAttribute('data-project-id')));
        }
    };

    const renderShowGiveWidget = function () {
        if (showGiveWidget) {
            return (
                <GiveWidget
                    showGiveWidget={showGiveWidget}
                    project={project}
                    projectId={project.id}
                    prepopulatedDonationAmount={prepopulatedDonationAmountForGiveWidget}
                    submitTakesUserDirectlyToCart={giveWidgetSubmitTakesUserDirectlyToCart}
                    hideCompleteProjectCallout={true}
                />
            );
        }
    };

    const formatShortenedDate = function(date) {
        if (date) {
            return new Date(date).toLocaleDateString('en-us');
        }
        return '';
    }

    return (
        <div className={'col col4' + (className ? ' ' + className : '')}>
            <div className={"project-card-small " +  (hasMatch(project) ? 'matched' : '')}>
                <a className='project-page-link' href={proposalURL} data-project-id={project.id} onClick={onClick}/>
                <div className="classroom-photo" style={{ backgroundImage: 'url(' + imageURL + ')' }}>
                    <AddToProjectFavoritesWidget
                        projectId={parseInt(project.id)}
                        isEligibleForFunding={incomplete}
                        initFavStatus={false}
                        userId={parseInt(userId)}
                        favoritesStyle={FAVORITES_STYLE.heart}
                    />
                    <div className="project-title"
                        dangerouslySetInnerHTML={{ __html: project.title }}>
                    </div>
                </div>
                {!(project.fundingStatus === 'funded' && altViewForFullyFundedProjects) ?
                    <div className="project-description">
                        {projectFormatter.formatMyStudentsNeed(project)}
                    </div> : ''}
                {project.fundingStatus === 'funded' && altViewForFullyFundedProjects ?
                    <div className="project-fully-funded">
                        {'Fully Funded ' + formatShortenedDate(project.fullyFundedDate)}
                    </div> : ''}
                <div className="teacher-info">
                    {makeTeacherAndSchoolInfo(project)}
                </div>
                {project.fundingStatus === 'funded' && altViewForFullyFundedProjects ? '' : <ProgressBar project={project} /> }
                <div className="project-data">
                    <ProjectCost project={project} amountGiven={amountGiven}/>
                    {project.fundingStatus === 'funded' && altViewForFullyFundedProjects ?
                        <div className="student-impact">
                            <b>{project.numStudents}</b> students impacted
                        </div> : '' }
                </div>
                {makeMatchExplanation()}
            </div>
            {renderShowGiveWidget()}
        </div>
    );
};

SmallProjectCard.propTypes = {
    project: PropTypes.object.isRequired,
    showGiveWidget: PropTypes.bool,
    prepopulatedDonationAmountForGiveWidget: PropTypes.number,
    giveWidgetSubmitTakesUserDirectlyToCart: PropTypes.bool,
    amountGiven: PropTypes.number,
    className: PropTypes.string,
    onProjectCardClick: PropTypes.func,
    altViewForFullyFundedProjects: PropTypes.bool,
};

SmallProjectCard = React.memo(SmallProjectCard);
